<mat-dialog-content class="mat-typography sm:min-w-120">
    <div class="grid col-span-1 sm:grid-cols-8 sm:gap-x-2 mt-2 gap-y-2 sm:gap-y-0">
        <div class="col-span-1 sm:col-span-5 flex flex-col rounded-xl bg-slate-800 w-full p-3 text-white text-center" matTooltip="{{data.title}} ">
            <div class="truncate">
                {{data.title}}
            </div>
        </div>
        <div class="col-span-1 flex flex-row rounded-xl bg-slate-600 w-full p-3 text-white items-center justify-center space-x-2">
            <ng-container *ngIf="data.email_notification">
                <mat-icon class="icon-size-6 text-white" matTooltip="Notificación por E-mail" [svgIcon]="'mat_outline:mail_outline'"></mat-icon>
            </ng-container>
            <ng-container *ngIf="data.internal_notification">
                <mat-icon class="icon-size-6 text-white" matTooltip="Notificación Interna" [svgIcon]="'mat_outline:notifications_active'"></mat-icon>
            </ng-container>
        </div>
        <div class="col-span-2 flex flex-col rounded-xl bg-amber-600 w-full p-3 text-white text-center truncate sm:w-full">
            <div class="truncate">
                {{data.created_at | date: 'dd/MM/yyyy'}}
            </div>
        </div>
    </div>
    <div class="col-span-1 sm:col-span-2 mt-2 flex flex-col rounded-xl bg-slate-50 border border-slate-200 w-full p-3">
        <div class="prose max-w-none" [innerHTML]="sanitizedMessage"></div>
    </div>

    <div>
        <mat-checkbox class="mt-4" #ackCheckbox [formControl]="confirmChecked">
            Confirmo haber leído la notificación.
        </mat-checkbox>
    </div>

    <mat-divider></mat-divider>

    <div class="flex flex-row justify-around items-center mt-4 text-center">
        <button *ngIf="data.pdf" (click)="showPDF()" mat-button color="warn" class="flex flex-row space-x-2 bg-rose-50 hover:bg-rose-100 ">
            <mat-icon class="icon-size-5" svgIcon="mat_outline:download"></mat-icon>
            <span class="pr-3">
                Descargar PDF
            </span>
        </button>
        <div class="mt-4 text-center" [matTooltip]="confirmChecked.value ? null : 'Primero debes confirmar que has leído la notificación.'">
            <button [disabled]="!confirmChecked.value" mat-button (click)="markRead()">Cerrar</button>
        </div>

    </div>
</mat-dialog-content>